import React from 'react'
import { connect } from 'react-redux'
import BigCalendar from 'react-big-calendar'
import moment from 'moment'
import { chain, flatten, compact } from 'lodash'
import { createSelector } from 'reselect'
import { browserHistory } from "react-router"
import { ButtonGroup } from 'react-bootstrap'

import "./DashboardPage.less"
import { getTripTab, getStatusLabel } from '../trips/TripStatus'
import { str2moment } from '../../lib/Tools'
import Button from "../components/Button"
import { getTransportationTexts } from '../lib/text'
import CityColorer from '../lib/CityColorer';

const pastMonth = () => moment().subtract(1, "month").startOf("month").format("YYYY/MM/DD")

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment))

class Calendar extends React.PureComponent 
{
  constructor(props) {
    super(props)
    this.state = { mode: "arrivals" }
  }

  render() {
    return (
      <div className="dashboard-page">
        <div className="calendar-title-row">
          <h3>Calendario</h3>
          <ButtonGroup>
            <Button
              active={this.state.mode == "arrivals"}
              onClick={() => this.setState({ mode: "arrivals" })}
            >
              🛬 Llegadas
            </Button>
            <Button
              active={this.state.mode == "stays"}
              onClick={() => this.setState({ mode: "stays" })}
            >
              📅 Estancias
            </Button>
            <Button
              active={this.state.mode == "transports"}
              onClick={() => this.setState({ mode: "transports" })}
            >
              🚂 Transportes
            </Button>
          </ButtonGroup>
        </div>
        <div className="dashboard-calendar-wrapper">
          <BigCalendar
            events={this.props[this.state.mode] || []}
            views={[ "month", "week", "day", "agenda" ]}
            step={60}
            showMultiDayTimes
            defaultDate={new Date()}
            culture="es"

            eventPropGetter={event => ({
              style: { backgroundColor: event.color }
            })}

            selectable
            onSelectEvent={(event, synthEventIgnored) => {
              const { id, name } = event.data
              if (confirm(`¿Ir al viaje de ${name}?`)) {
                browserHistory.push(`/private/trip/${id}`)
              }
            }}
          />
        </div>
      </div>
    )
  }
}

const tabsToInclude = { cerrados: true, aprobados: true, contrato: true }

const calendarTrips = createSelector(
  [(state => state.trips)],
  trips => {
    const pm = pastMonth()
    console.log(`pm: ${pm}`)
    return chain(trips)
      .values()
      .filter(t => (
        !t.deleted 
        && t.startDate > pm
        && t.status < 100 // not lost
        && tabsToInclude[getTripTab(t)]
      ))
      .value()
  }
)

const tripsToEvents = createSelector(
  [calendarTrips],
  trips => {
    const pm = pastMonth()
    console.log(`pm: ${pm}`)
    return trips.map(t => ({
      id: t._id, 
      title: `(${getStatusLabel(t.status)}) Viaje de ${t.name} (${t.realName})`,
      start: new Date(t.startDate),
      end: new Date(t.endDate || t.startDate), 
      data: {
        id: t._id, 
        name: `${t.name} (${t.realName})`,
        shortName: t.realName || t.name,
      }
    }))
  }
)

const transportationEvents = createSelector(
  [calendarTrips, (state => state.routes), (state => state.cities)],
  (trips: array, routes: Object, cities: Object) => {
    const cc = new CityColorer()
    return compact(flatten(
      trips.map(
        trip => {
          const route = routes[trip.mainRoute]

          if (!route || !route.agenda || !trip.startDate) {
            return null
          }

          let dayCount = -1
          const baseDate = str2moment(trip.startDate).toDate()

          return route.agenda
            .map((item, i) => {
              if (item.type === "day") {
                ++dayCount
              }
              const date = str2moment(trip.startDate).add(dayCount, "days").toDate()
              if (item.type === "city") {
                const color = cc.get(trip._id)

                if (!item.transport) {
                  console.log(`Broken transport-item (${i}) in ${trip.name} (${trip._id})`)
                }

                const means = item.transport && item.transport.means ? getTransportationTexts(item.transport.means).icon : "❓ "

                return ({
                  color,
                  id: `${trip._id}:${item.key}`,
                  title: `${means} ${cities[item.city].name} (${trip.realName || trip.name})`,
                  start: date,
                  end: date,
                  data: {
                    id: trip._id, 
                    name: `${trip.name} (${trip.realName})`,
                    shortName: trip.realName || trip.name,
                  }
                })
              }
            })
        }
      )
    ))
  }
)

const mapStateToProps = (state, ownProps) => ({
  stays: tripsToEvents(state, ownProps),
  arrivals: tripsToEvents(state, ownProps).map(x => ({ 
    ...x, 
    id: `arrival-${x.id}`,
    end: x.start,
    title: `🛬 ${x.data.shortName}`,
    color: "#f7c259"
  })),
  transports: transportationEvents(state, ownProps),
})

export default connect(mapStateToProps)(Calendar)

